import ES from '@/components/js/EditorSetting.js'
import {closest, resetRange, eventRange, getSibling, getTagElementAction, changeParents, changeParent, changeTag} from '@/components/js/Utils.js'

export default class Editor extends ES {
  update (type, value) {
    console.log('update', type, value)
  }

  resetType () {
    console.log('resetType')
  }

  constructor ($select) {
    super()
    ES._select = $select
  }

  getType (e) {
    if (closest(e.target, ES.ENTER)) {
      return ES.TYPE_TEXT
    } else if (closest(e.target, ES.IMG)) {
      closest(e.target, ES.IMG).classList.add(ES.toSELECT)
      setTimeout(() => {
        console.log('check', e.target)
        resetRange(closest(e.target, ES.IMG).childNodes[0])
      })
      return ES.TYPE_IMG
    } else if (closest(e.target, ES.LINE)) {
      closest(e.target, ES.LINE).classList.add(ES.toSELECT)
      setTimeout(() => {
        resetRange(closest(e.target, ES.LINE).childNodes[0])
      })
      return ES.TYPE_LINE
    } else if (closest(e.target, ES.BLOCK)) {
      return ES.TYPE_BLOCK
    }
    return ES.TYPE_TEXT
  }

  updateTool (type) {
    var r = this.range
    var s = r.startContainer
    var o, f, b
    switch (type) {
      case ES.TYPE_TEXT :
      case ES.TYPE_BLOCK :
        this.update(ES.toolBOLD, closest(s, 'b') !== null)
        this.update(ES.toolITALIC, closest(s, 'i') !== null)
        this.update(ES.toolUNDERLINE, closest(s, 'u') !== null)
        this.update(ES.toolSTRIKE, closest(s, 'strike') !== null)
        switch (type) {
          case ES.TYPE_TEXT :
            f = closest(s, 'a')
            if (f === null) {
              this.update(ES.toolLINK, null)
            } else {
              this.update(ES.toolLINK, f.href)
            }
            f = closest(s, ES.ENTER)
            if (f === null) {
              this.update(ES.toolAlign, ES.ALIGN_LEFT)
              this.update(ES.toolINDENT, false)
            } else {
              this.update(ES.toolAlign, f.align)
              this.update(ES.toolINDENT, f.classList.contains(ES.toolINDENT))
            }
            f = closest(s, 'font')
            if (f === null) {
              this.update(ES.toolFONT, null)
              this.update(ES.toolSize, null)
              this.update(ES.toolForeCOLOR, null)
            } else {
              this.update(ES.toolFONT, f.face ? f.face : null)
              this.update(ES.toolSize, f.size ? f.size : null)
              this.update(ES.toolForeCOLOR, f.color ? f.color : null)
            }
            b = closest(s, 'span')
            if (b === null) {
              this.update(ES.toolBackCOLOR, null)
            } else {
              console.log(b.style.backgroundColor)
              if (b.style.backgroundColor !== '') {
                this.update(ES.toolBackCOLOR, this.rgbToHex(b.style.backgroundColor))
              } else {
                this.update(ES.toolBackCOLOR, null)
              }
            }
            break
          case ES.TYPE_BLOCK :
            b = closest(s, ES.BLOCK)
            for (f in b.classList) {
              switch (b.classList[f]) {
                case ES.ALIGN_LEFT :
                case ES.ALIGN_RIGHT :
                case ES.ALIGN_CENTER :
                case ES.ALIGN_JUSTIFY :
                  this.update(ES.toolAlign, b.classList[f])
                  break
              }
            }
            if (b.style.color) {
              this.update(ES.toolForeCOLOR, this.rgbToHex(b.style.color))
            } else {
              this.update(ES.toolForeCOLOR, null)
            }
            if (b.style.backgroundColor) {
              this.update(ES.toolBackCOLOR, this.rgbToHex(b.style.backgroundColor))
            } else {
              this.update(ES.toolBackCOLOR, null)
            }
            break
        }
        break
      case ES.TYPE_LINE :
        s = document.querySelector(ES.SELECT + ' span')
        for (o in s.classList) {
          switch (s.classList[o]) {
            case ES.SIZE_LARGE :
            case ES.SIZE_MIDDLE :
            case ES.SIZE_SMALL :
              this.update(ES.toolSize, s.classList[o])
              break
            case ES.STYLE_SOLID :
            case ES.STYLE_INSET :
            case ES.STYLE_DOUBLE :
            case ES.STYLE_DASHED :
              this.update(ES.toolStyle, s.classList[o])
              break
          }
        }
        if (s.style['border-bottom-color']) {
          this.update(ES.toolForeCOLOR, this.rgbToHex(s.style['border-bottom-color']))
        } else {
          this.update(ES.toolForeCOLOR, null)
        }
        break
      case ES.TYPE_IMG :
        s = document.querySelector(ES.SELECT + ' img')
        for (o in s.classList) {
          switch (s.classList[o]) {
            case ES.STYLE_FULL :
            case ES.STYLE_ORG :
              this.update(ES.toolStyle, s.classList[o])
              break
          }
        }
        break
    }
  }

  isParagraph (n) {
    console.log('isParagraph', n, n.nextSibling)
    if (n.nextSibling === null) {
      var temp = document.createElement(ES.ENTER)
      temp.align = ES.ALIGN_LEFT
      temp.appendChild(document.createElement('br'))
      n.parentNode.appendChild(temp)
    }
  }

  toHex (string) {
    string = parseInt(string, 10).toString(16)
    string = (string.length === 1) ? '0' + string : string
    return string
  }

  rgbToHex (rgb) {
    rgb = rgb.replace(/[^%,.\d]/g, '')
    rgb = rgb.split(',')
    for (var x = 0; x < 3; x++) {
      if (rgb[x].indexOf('%') > -1) rgb[x] = Math.round(parseFloat(rgb[x]) * 2.55)
    }
    var r = this.toHex(rgb[ 0 ])
    var g = this.toHex(rgb[ 1 ])
    var b = this.toHex(rgb[ 2 ])
    return '#' + r + g + b
  }

  parentChange (t, n) {
    if (n.parentNode !== t) {
      var p = n.parentNode
      var pp = p.parentNode
      console.log('parentChange 1', pp.outerHTML)
      if (pp) {
        pp.insertBefore(n, p)
        if (!p.childNodes.length) {
          pp.removeChild(p)
        }
      }
      console.log('parentChange 1', pp.outerHTML)
    }
  }

  paste (e) {
    var st = ''
    e.pasteHTML.childNodes.forEach((item) => {
      switch (item.nodeType) {
        case 3 :
          st += item.nodeValue
          break
        case 1 :
          st += item.outerHTML
          break
      }
    })
    console.log(st)
    document.execCommand('insertHTML', false, st)
    document.querySelectorAll('.u_textEdit ' + ES.ENTER).forEach((item) => {
      if (item.align === '') {
        item.align = ES.ALIGN_LEFT
      }
    })
    document.querySelectorAll('span[style]').forEach((n) => {
      if (n.style.backgroundColor === 'var(--bg-white)' && n.classList.length === 0) {
        changeParent(n)
      }
    })
    document.querySelectorAll('a[style]').forEach((n) => {
      if (n.style.backgroundColor === 'var(--bg-white)' && n.classList.length === 0) {
        n.removeAttribute('style')
      }
    })
    this.updateTool()
  }

  removeTag (de, tag) {
    de.querySelectorAll(tag).forEach((item) => item.parentNode.removeChild(item))
  }

  dragHTML (e) {
    return this.parseHTML(e.dataTransfer.getData('text/html'))
  }

  parseHTML (st) {
    console.log('parseHTML', st)
    var de = document.createElement('div')
    st = st.replace(new RegExp('<!--(.*?)-->', 'gis'), '')
    st = st.replace(/<!\[if(.*?)\]>/gim, '').replace(/<!\[endif\]>/gim, '')
    st = st.replace(/<o:p><\/o:p>/gim, '').replace(/<o:p\/>/gim, '')
    st = st.replace(/\s+&nbsp;\s+/gim, '&nbsp;')
    console.log('parseHTML', st)
    de.innerHTML = st
    de.className = 'u_tag'
    this.removeTag(de, 'meta')
    this.removeTag(de, 'ul')
    this.removeTag(de, 'button')
    this.removeTag(de, 'style')
    de.childNodes.forEach((item) => {
      if (item.nodeType === 8) {
        de.removeChild(item)
      }
    })
    if (!de.querySelectorAll('p').length) {
      var p = document.createElement('p')
      while (de.firstChild) {
        p.appendChild(de.firstChild)
      }
      de.appendChild(p)
    }
    de.querySelectorAll('p').forEach((item) => {
      if (item.outerText === '') {
        item.parentNode.removeChild(item)
      } else {
        changeTag(item, 'p')
      }
    })
    de.querySelectorAll('p').forEach((item) => {
      while (item.parentNode !== de) {
        this.parentChange(de, item)
      }
    })
    changeParents(de, 'span', null, 'u_tag')
    changeParents(de, 'mark', null, 'u_tag')
    changeParents(de, 'a', null, 'u_tag')
    changeParents(de, 'u', null, 'u_tag')
    console.log(de.outerHTML)
    de.querySelectorAll('br').forEach((item) => {
      var ps = document.createElement('p')
      var pe = document.createElement('p')
      var pr = item.parentNode
      var pp = pr.parentNode
      var bo = false
      while (pr.firstChild) {
        if (bo) {
          pe.appendChild(pr.firstChild)
        } else {
          if (pr.firstChild === item) {
            bo = true
            pr.removeChild(item)
          } else {
            ps.appendChild(pr.firstChild)
          }
        }
      }
      setTimeout(() => {
        console.log(pp, item, pe.outerHTML, pr)
      })
      pp.replaceChild(pe, pr)
      pp.insertBefore(ps, pe)
    })
    de.querySelectorAll('div').forEach((item) => {
      if (item.parentNode !== null && !item.classList.contains('u_tag')) {
        item.parentNode.removeChild(item)
      }
    })
    de.querySelectorAll('p').forEach((item) => {
      if (item.innerHTML.replace(/(^\s*)/gi, '').length === 0) {
        item.innerHTML = '&#160;'
      }
    })
    console.log('parseHTML', de.outerHTML)
    return de
  }

  pasteHTML (e) {
    console.log(e.clipboardData)
    console.log(e)
    var d = (e.clipboardData || window.clipboardData)
    if (d.getData('text/html') === '') {
      return this.parseHTML('<p>' + d.getData('text').replace(/\r\n/g, '</p><p>') + '</p>')
    } else {
      return this.parseHTML(d.getData('text/html'))
    }
  }

  copy (type, e) {
    var t = document.querySelector(ES.SELECT)
    var c = (e.clipboardData || window.clipboardData || e.originalEvent.clipboardData)
    switch (type) {
      case ES.TYPE_LINE :
      case ES.TYPE_IMG :
        c.setData('text/html', t.outerHTML)
        e.preventDefault()
        break
    }
  }

  cut (type, e) {
    console.log('cut')
    var t = document.querySelector(ES.SELECT)
    var c = (e.clipboardData || window.clipboardData || e.originalEvent.clipboardData)
    switch (type) {
      case ES.TYPE_LINE :
      case ES.TYPE_IMG :
        c.setData('text/html', t.outerHTML)
        t.parentNode.removeChild(t)
        e.preventDefault()
        break
      default :
        document.execCommand('copy', null, null)
        e.preventDefault()
        // console.log(a.toString())
        // c.setData('text/html', t.outerHTML)
        break
    }
  }

  dragstart (type, e) {
    var t = document.querySelector(ES.SELECT)
    switch (type) {
      case ES.TYPE_LINE :
      case ES.TYPE_IMG :
      case ES.TYPE_SECTION :
      case ES.TYPE_POINT :
        e.dataTransfer.dropEffect = 'move'
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.clearData()
        e.dataTransfer.setData('text/html', t.outerHTML)
        break
    }
  }

  drop (type, e) {
    switch (type) {
      case ES.TYPE_LINE :
      case ES.TYPE_IMG :
      case ES.TYPE_SECTION :
      case ES.TYPE_POINT :
        resetRange(eventRange(e))
        var t = document.querySelector(ES.SELECT)
        t.parentNode.removeChild(t)
        document.execCommand('insertHTML', false, e.dataTransfer.getData('text/html'))
        resetRange(document.querySelector(ES.SELECT))
        e.preventDefault()
        break
    }
  }

  keydown (type, e) {
    var t, p
    var r = this.range
    // console.log(e)
    switch (e.keyCode || e.which) {
      case 8 :
      // backspace
        // console.log('editor keydown', r)
        switch (type) {
          case ES.TYPE_LINE :
          case ES.TYPE_IMG :
            this.command(type, null, ES.toolREMOVE, 'prev')
            e.preventDefault()
            break
          case ES.TYPE_BLOCK :
            if (r.startOffset === 0) {
              this.command(type, r, ES.toolREMOVE)
              e.preventDefault()
            }
            break
          case ES.TYPE_TEXT :
            if (r.startOffset === 0 && ES.isCollapsed) {
              if (this.removeElementIsType(r.startContainer, 'prev')) {
                e.preventDefault()
              } else {
                t = document.querySelector('.u_textEdit')
                p = t.querySelectorAll(ES.ENTER)
                if (p.length === 1 && escape(p[0].outerText) === '%0A') {
                  e.preventDefault()
                }
              }
            }
            break
        }
        break
      case 13 :
      // enter
        switch (type) {
          case ES.TYPE_BLOCK :
            console.log('block enter')
            t = document.createElement('br')
            r.insertNode(t)
            resetRange(t.nextSibling, 0)
            e.preventDefault()
            break
          case ES.TYPE_LINE :
          case ES.TYPE_IMG :
            e.preventDefault()
            break
        }
        break
      case 32 :
        switch (type) {
          case ES.TYPE_LINE :
          case ES.TYPE_IMG :
            e.preventDefault()
            break
        }
        break
      case 46 :
      // delete
        switch (type) {
          case ES.TYPE_LINE :
          case ES.TYPE_IMG :
            this.command(type, null, ES.toolREMOVE, 'next')
            e.preventDefault()
            break
          case ES.TYPE_TEXT :
            console.log('check', r.startOffset === r.startContainer.length)
            if (r.startOffset === r.startContainer.length && ES.isCollapsed) {
              if (this.removeElementIsType(r.startContainer, 'next')) {
                e.preventDefault()
              }
            }
            break
          case ES.TYPE_BLOCK :
            console.log(r.startOffset, r.startContainer.length)
            if (r.startOffset === r.startContainer.length) {
              this.command(type, r, ES.toolREMOVE)
              e.preventDefault()
            }
            break
        }
        break
      case 67 :
        if (e.ctrlKey) {
          console.log('key')
          // console.log(editor.range)
        }
        break
      case 37 :
      case 38 :
      case 39 :
      case 40 :
        if (closest(this.range.startContainer, ES.SELECT)) {
          resetRange(this.range.startContainer, 0)
        }
        setTimeout(() => {
          this.resetType()
        })
        break
    }
  }

  removeElementIsType (node, action) {
    var p = getTagElementAction(node, ES.ENTER, action)
    var a = (action === 'next') ? 'nextSibling' : 'previousSibling'
    console.log('removeElementIsType', p[a])
    if (closest(p[a], ES.LINE) || closest(p[a], ES.IMG)) {
      var va = (action === 'next') ? 'prev' : 'next'
      p[a].classList.add(ES.toSELECT)
      this.command(ES.TYPE_LINE, null, ES.toolREMOVE, va)
      return true
    }
    return false
  }

  keyup (e) {
    switch (e.keyCode || e.which) {
      case 8 :
      // backspace
        break
    }
  }

  selectRemove (action) {
    var t = document.querySelector(ES.SELECT)
    var p = getSibling(t, action)
    t.parentNode.removeChild(t)
    this.moveFocus(p.target, p.action)
  }

  moveFocus (target, action) {
    if (target.nodeName === ES.ENTER) {
      var c
      switch (action) {
        case 'prev' :
          c = target.childNodes[target.childNodes.length - 1]
          resetRange(c, c.length)
          break
        case 'next' :
          c = target.childNodes[0]
          resetRange(c, 0)
          break
      }
      this.update(ES.toolTYPE, ES.TYPE_TEXT)
    } else {
      resetRange(target)
      this.mousedown({target: target})
    }
  }

  command (type, focus, cmd, value) {
    var r = this.range
    var t = document.querySelector(ES.SELECT)
    var oh, p, h
    switch (cmd) {
      case ES.toolFONT :
        switch (type) {
          // case ES.TYPE_BLOCK :
          //   t = closest(r.startContainer, ES.BLOCK)
          //   t.classList.remove(ES.ALIGN_LEFT, ES.ALIGN_RIGHT, ES.ALIGN_CENTER, ES.ALIGN_JUSTIFY)
          //   t.classList.add(value)
          //   break
          default :
            this.defaultCommand(focus, cmd, value)
            break
        }
        break
      case ES.toolAlign :
        t = ES.getRangeTarget(r)
        p = t.end
        t = t.start
        switch (type) {
          case ES.TYPE_TEXT :
            while (t !== null) {
              if (t.nodeName.toLocaleLowerCase() === ES.ENTER.toLocaleLowerCase()) {
                t.align = value
              }
              t = (t !== p) ? t.nextSibling : null
            }
            break
          case ES.TYPE_BLOCK :
            while (t !== null) {
              if (t.nodeName.toLocaleLowerCase() === ES.BLOCK.toLocaleLowerCase()) {
                t.classList.remove(ES.ALIGN_LEFT, ES.ALIGN_RIGHT, ES.ALIGN_CENTER, ES.ALIGN_JUSTIFY)
                t.classList.add(value)
              }
              t = (t !== p) ? t.nextSibling : null
            }
            break
          case ES.TYPE_INDEX :
            while (t !== null) {
              if (t.classList.contains(ES.toINDEX)) {
                t.classList.remove(ES.ALIGN_LEFT, ES.ALIGN_RIGHT, ES.ALIGN_CENTER, ES.ALIGN_JUSTIFY)
                t.classList.add(value)
              }
              t = (t !== p) ? t.nextSibling : null
            }
            break
        }
        break
      case ES.toolITALIC :
      case ES.toolBOLD :
        switch (type) {
          case ES.TYPE_BLOCK :
            t = closest(r.startContainer, ES.BLOCK)
            resetRange(t)
            break
        }
        document.execCommand(cmd, false, value)
        break
      case ES.toolLINE :
        resetRange(focus)
        h = document.createElement('div')
        h.className = 'u_tag dragtarget line ' + ES.toSELECT
        h.innerHTML = '<span class="' + ES.SIZE_LARGE + ' ' + ES.STYLE_SOLID + '"/>'
        document.execCommand('insertHTML', false, h.outerHTML)
        oh = document.querySelector(ES.SELECT)
        this.isParagraph(oh)
        resetRange(oh.querySelector('span'))
        this.update(ES.toolTYPE, ES.TYPE_LINE)
        this.update(ES.toolSize, ES.SIZE_LARGE)
        this.update(ES.toolStyle, ES.STYLE_SOLID)
        break
      case ES.toolIMG :
        resetRange(focus)
        h = document.createElement('div')
        h.className = 'u_tag img ' + ES.toSELECT
        h.innerHTML = '<img class="' + ES.STYLE_FULL + '" id="' + Date.now() + '" src="' + value + '"/>'
        var bobo = document.execCommand('insertHTML', false, h.outerHTML)
        oh = document.querySelector(ES.SELECT)
        console.log('select', bobo, oh)
        this.isParagraph(oh)
        resetRange(oh.querySelector('img'))
        this.update(ES.toolTYPE, ES.TYPE_IMG)
        this.update(ES.toolStyle, ES.STYLE_FULL)
        break
      case ES.toolLINK :
        if (value === null || value === '') {
          t = closest(focus.startContainer, 'a')
          resetRange(t.firstChild, 0, t.lastChild, t.lastChild.length)
          document.execCommand('unlink', false, null)
        } else {
          console.log('link check', value)
          if (value.indexOf('http://') === -1 && value.indexOf('https://') === -1) {
            value = 'http://' + value
          }
          var selection = document.getSelection()
          this.defaultCommand(focus, cmd, value)
          selection.anchorNode.parentElement.target = '_blank'
        }
        this.update(ES.toolLINK, value)
        break
      case ES.toolStyle :
        switch (type) {
          case ES.TYPE_LINE :
            t.querySelector('span').classList.remove(ES.STYLE_SOLID, ES.STYLE_INSET, ES.STYLE_DOUBLE, ES.STYLE_DASHED)
            t.querySelector('span').classList.add(value)
            break
          case ES.TYPE_IMG :
            t.querySelector('img').classList.remove(ES.STYLE_FULL, ES.STYLE_ORG)
            t.querySelector('img').classList.add(value)
            break
          case ES.TYPE_BLOCK :
            t = closest(this.range.startContainer, ES.BLOCK)
            t.classList.remove(ES.STYLE_BLOCK01, ES.STYLE_BLOCK02, ES.STYLE_BLOCK03, ES.STYLE_BLOCK04)
            t.classList.add(value)
            break
        }
        break
      case ES.toolForeCOLOR :
        switch (type) {
          case ES.TYPE_LINE :
            if (value === null) {
              document.querySelector(ES.SELECT + ' span').style = null
            } else {
              document.querySelector(ES.SELECT + ' span').style['border-bottom-color'] = value
            }
            break
          case ES.TYPE_TEXT :
            this.defaultCommand(focus, cmd, value)
            break
          case ES.TYPE_BLOCK :
            t = closest(focus.startContainer, ES.BLOCK)
            if (value === null) {
              t.style.color = null
            } else {
              t.style.color = value
            }
            break
        }
        break
      case ES.toolBackCOLOR :
        console.log(cmd, value)
        switch (type) {
          case ES.TYPE_TEXT :
            this.defaultCommand(focus, cmd, value)
            break
          case ES.TYPE_BLOCK :
            t = closest(focus.startContainer, ES.BLOCK)
            console.log(focus)
            console.log(t.style)
            if (value === null) {
              t.style.backgroundColor = null
            } else {
              t.style.backgroundColor = value
            }
            break
        }
        break
      case ES.toolSize :
        switch (type) {
          case ES.TYPE_TEXT :
            console.log('checksize', value)
            this.defaultCommand(focus, 'fontSize', Number(value))
            // switch (value) {
            //   case '4' :
            //     console.log('checksize', value)
            //     this.defaultCommand(focus, 'fontSize', 'large')
            //     break
            //   case '3' :
            //     this.defaultCommand(focus, 'fontSize', 'medium')
            //     break
            //   case '2' :
            //     this.defaultCommand(focus, 'fontSize', 'small')
            //     break
            //   case '1' :
            //     this.defaultCommand(focus, 'fontSize', 'x-small')
            //     break
            // }
            break
          case ES.TYPE_LINE :
            t.querySelector('span').classList.remove(ES.SIZE_SMALL, ES.SIZE_MIDDLE, ES.SIZE_LARGE)
            t.querySelector('span').classList.add(value)
            break
        }
        break
      case ES.toolREMOVE :
        switch (type) {
          case ES.TYPE_LINE :
          case ES.TYPE_IMG :
            value = (value !== undefined ? value : 'next')
            this.selectRemove(value)
            break
          case ES.TYPE_BLOCK :
            t = ES.getRangeTarget(focus)
            p = t.end
            t = t.start
            h = t
            while (t !== null) {
              oh = (t !== p)
              if (t.nodeName.toLocaleLowerCase() === ES.BLOCK.toLocaleLowerCase()) {
                if (t === h) {
                  h = t = changeTag(t, ES.ENTER)
                  console.log(h)
                } else {
                  t = changeTag(t, ES.ENTER)
                }
                t.align = ES.ALIGN_LEFT
              }
              t = (oh) ? t.nextSibling : null
            }
            resetRange(h.firstChild, 0)
            setTimeout(() => {
              this.resetType()
            })
            break
        }
        break
      case ES.toolINDENT :
        t = ES.getRangeTarget(r)
        p = t.end
        t = t.start
        if (value) {
          while (t !== null) {
            if (t.nodeName === ES.ENTER) {
              t.classList.add(cmd)
            }
            t = (t !== p) ? t.nextSibling : null
          }
        } else {
          while (t !== null) {
            if (t.nodeName === ES.ENTER) {
              t.classList.remove(cmd)
            }
            t = (t !== p) ? t.nextSibling : null
          }
        }
        break
      case ES.toolBLOCK :
        t = ES.getRangeTarget(focus)
        p = t.end
        t = t.start
        h = t
        while (t !== null) {
          oh = (t !== p)
          if (t.nodeName === ES.ENTER) {
            changeParents(t, 'span', 'span', 'u_tag')
            changeParents(t, 'b', 'b', 'u_tag')
            changeParents(t, 'i', 'i', 'u_tag')
            changeParents(t, 'u', 'u', 'u_tag')
            changeParents(t, 'font', 'font', 'u_tag')
            changeParents(t, 'strike', 'strike', 'u_tag')
            if (t === h) {
              h = t = changeTag(t, ES.BLOCK)
            } else {
              t = changeTag(t, ES.BLOCK)
            }
            t.classList.add(ES.STYLE_BLOCK01, ES.ALIGN_LEFT)
          }
          t = (oh) ? t.nextSibling : null
        }
        resetRange(h.firstChild, 0)
        setTimeout(() => {
          this.resetType()
          this.isParagraph(h)
          console.log('create block')
        })
        break
      case ES.toolFOOTNOTE :
        focus.insertNode(value.element)
        break
      case ES.toolSECTION :
        if (document.querySelector(ES.SELECT)) {
          resetRange(document.querySelector(ES.SELECT).nextSibling, 0)
          document.querySelector(ES.SELECT).classList.remove(ES.toSELECT)
        } else if (!closest(r.startContainer, '.u_textEdit')) {
          resetRange(focus)
        }
        value.classList.add(ES.toSELECT)
        document.execCommand('insertHTML', false, value.outerHTML)
        oh = document.querySelector(ES.SELECT)
        this.isParagraph(oh)
        resetRange(oh.childNodes[0])
        this.update(ES.toolTYPE, ES.TYPE_SECTION)
        break
      case ES.toolLASTENTER :
        t = document.querySelector('.u_textEdit')
        var temp = document.createElement(ES.ENTER)
        temp.align = ES.ALIGN_LEFT
        temp.appendChild(document.createElement('br'))
        t.appendChild(temp)
        resetRange(temp.childNodes[0], 0)
        break
      default :
        if (r) {
          this.defaultCommand(focus, cmd, value)
        }
    }
  }

  defaultCommand (focus, cmd, value) {
    resetRange(focus)
    document.execCommand('styleWithCSS', false, false)
    if (value) {
      document.execCommand(cmd, false, value)
    } else {
      document.execCommand('removeFormat', false, cmd)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/js/Editor.js